<template>
    <div>
        <div>
            <v-data-table
                v-bind="{
                    items,
                    headers,
                }"
                disable-pagination
                disable-sort
                hide-default-footer
            >
                <template slot="item.purchaseNo" slot-scope="{ item }">{{ item.purchaseNo || item?.order?.orderNo }}</template>
                <template slot="item.product" slot-scope="{ item }">
                    <div class="d-flex align-center text-left">
                        <div>
                            <v-img :src="item?.product?.thumb" width="96" height="96" contain></v-img>
                        </div>
                        <div style="width:calc(100% - 96px);">
                            <div class="mx-2 text-truncate"><b class="text-truncate" v-html="item.product.name"></b></div>
                            <div class="mx-2 text-truncate">{{ item.product.salePrice.format() }}원</div>
                        </div>
                    </div>
                </template>
                <span slot="item.status" slot-scope="{ item }">{{ item.status || item.purchase?.status }}</span>
                <span slot="item.createdAt" slot-scope="{ item }">{{ $dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss") }}</span>
                <span slot="item.resend" slot-scope="{ item }">
                    <v-icon v-if="item.issue?.pins?.length" small @click="resend(item)">mdi-message</v-icon>
                </span>
                <div slot="item.shippingInfo" slot-scope="{ item }">
                    <div>{{ item.shippingInfo.method }}</div>
                    <div>{{ item.shippingInfo.invoiceNumber }}</div>
                    <div>{{ couriers.find((courier) => courier.value == item.shippingInfo.courier)?.text }}</div>
                </div>
                <div slot="item.actions" slot-scope="{ item }"></div>
            </v-data-table>
        </div>

        <div class="mt-30px mt-md-40px">
            <v-pagination
                v-bind="{
                    value: page,
                    length: pageCount,
                    'total-visible': 11,
                }"
                @input="(page) => $router.push({ query: { ...$route.query, page } })"
            />
        </div>
        <claim-dialog ref="claimDialog" @claim="search" />
    </div>
</template>
<script>
import api from "@/api";
import couriers from "@/assets/data/couriers.json";

import ClaimDialog from "@/components/client/mypage/claim-dialog.vue";

const headers = [
    { text: "구매주문번호", value: "purchaseNo", align: "center", width: "17%" },
    { text: "구매상품", value: "product", align: "center", width: "45%" },
    { text: "구매수량", value: "quantity", align: "center", width: "12%" },
    { text: "선물상태", value: "giftStatus", align: "center", width: "12%" },
    { text: "주문일자", value: "createdAt", align: "center", width: "14%" },
    // { text: "-", value: "actions", align: "center" },
];

export default {
    components: {
        ClaimDialog,
    },
    props: {
        isOn: { type: Boolean, default: false },
    },
    data: () => ({
        purchases: [],
        summary: { totalCount: 0 },

        limit: 10,

        headers,
        couriers,

        loading: false,
    }),
    computed: {
        items() {
            return [...this.purchases];
        },
        page() {
            return +(this.$route.query.page || "1");
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            let { ...query } = this.$route.query;

            query.code = "gift";

            return { ...query };
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        params() {
            this.search();
        },
    },
    methods: {
        async init() {
            this.search();
        },
        async search() {
            if (!this.isOn) return;

            if (this.loading) return;
            else this.loading = true;

            try {
                let { skip, limit, params } = this;
                let { summary, purchases } = await api.v1.me.shop.purchases.gets({
                    headers: { skip, limit },
                    params,
                });
                this.purchases = purchases;
                this.summary = summary;
            } finally {
                this.loading = false;
            }
        },

        ////////////////////////////////////////////////////////////////////////
        // 항목 메소드
        ////////////////////////////////////////////////////////////////////////
        async claim(purchase, claimType) {
            this.$refs.claimDialog.claimType = claimType;
            this.$refs.claimDialog.purchase = purchase;
            this.$refs.claimDialog.open();
        },
        async resend(purchase) {
            await api.v1.me.shop.purchases.resend(purchase);
            alert("재발송되었습니다");
        },
    },
};
</script>

<style scoped></style>
